import {PageList, PageListReq,Result} from "@/types/api";
import apiClient from "../apiClient";
import type * as Domain from "@/core/user-manage/userManageDomain.ts";
import type * as Entity from "@/core/user-manage/userManageEntity.ts";

export enum Api {
    getPersonalUserList = "/admin/user/center/personal/page",
    getPersonalUsersList = "/admin/user/center/personal/page",
    getOperateUserList = "/admin/user/center/operate/page",
    getOperateUserListInInteractive= "/admin/user/center/operate/interactive",
    getEnterpriseUserList = "/admin/user/center/enterprise/page",
    upsertEnterpriseUser = "/admin/user/center/enterprise",
    updateOfficeUser = "/admin/user/center/official/",
    upsertOfficeUser = "/admin/user/center/official",
    updateEnterpriseUser = "/admin/user/center/enterprise",
    getOfficeList = "/admin/user/center/official/page",
    onViewOperator = "/admin/user/center/enterprise/operate/bind",
    getUserFollowers = "/admin/user/center/follow",
    getUserFans= "/admin/user/center/fans",
    getUserOperateGroup = "/admin/user/center/operate/group",
    getAllUserList = "/admin/user/center/page",
    getOperateUsersList = "/admin/user/center/operate/page",
    getOperateAllUsersList = "/admin/user/center/operate-enterprise-page",
    followUser = "/admin/user/center/follow/actions",
    getSchoolList = '/admin/school/page',
    getQsSchool = '/admin/school/qs',
    createUserOperateMock = '/admin/user/center/batch/mascot',
    getUserRelations = '/admin/user/relation',
    updateUserRelations = '/admin/user/relation',
    createUserOperateGroup = '/admin/user/center/batch/mock/mascot',
    createUserBatchOperateGroup = '/admin/user/center/batch/mascot',
    getUserAllocationData = '/admin/user/center/allocation/data',
}
const createUserOperateMock = (data: any[] | any) =>
    apiClient.put<Result<Entity.RIPageAppUserVO>>({
        url: Api.createUserOperateMock,
        data,
    });
const getPersonalUserList = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.post<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getPersonalUserList,
        data,
    });
const getsPersonalUserList = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.get<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getPersonalUserList,
        params:data,
    });
const getSchoolList = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.post<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getSchoolList,
        data,
    });
const getQsSchool = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.get<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getQsSchool,
        params:data,
    });
const getPersonalUsersList = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.get<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getPersonalUsersList,
        params:data,
    });
const getOfficeList = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.get<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getOfficeList,
        params:data,
    });
const getEnterpriseUserList = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.get<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getEnterpriseUserList,
        params:data,
    });
const getOperateUsersList = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.get<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getOperateUsersList,
        params:data,
    });
const getOperateAllUsersList = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.post<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getOperateAllUsersList,
        data,
    });
const getEnterpriseUserDetail = (userId: string) =>
    apiClient.get<Entity.RIAppUserDataVO>({
        url: `/admin/user/center/${userId}`,
    });
const upsertEnterpriseUser = (data: Partial<Domain.EnterpriseUser>) =>
    apiClient.post<Result<Domain.EnterpriseUser>>({
        url: Api.upsertEnterpriseUser,
        data
    });
const upsertOfficeUser = (data: Partial<Domain.EnterpriseUser>) =>
    apiClient.post<Result<Domain.EnterpriseUser>>({
        url: Api.upsertOfficeUser,
        data
    });
const updateOfficeUser = (data: Partial<Domain.EnterpriseUser>) => {
    const { userId, ...rest } = data;
    return apiClient.put<Result<Domain.EnterpriseUser>>({
        url: `${Api.updateOfficeUser}${userId}`,
        data: {
            ...rest
        }
    });
};
const updateEnterpriseUser = (data: Partial<Domain.EnterpriseUser>) =>
    apiClient.put<Result<Entity.RIPageAppUserVO>>({
        url: Api.upsertEnterpriseUser,
        data
    });
const onViewOperator = (data: any) =>
    apiClient.post<Result<Entity.RIPageAppUserVO>>({
        url: Api.onViewOperator,
        data
    });
const getOperateUserList = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.post<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getOperateUserList,
        data,
    });
const getUserFollowers = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.post<PageList<Entity.UserItem>>({
        url: Api.getUserFollowers,
        data,
    });
const getUserFans = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.post<PageList<Entity.UserItem>>({
        url: Api.getUserFans,
        data,
    });
const getUserOperateGroup = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.get<Entity.UserItem[]>({
        url: Api.getUserOperateGroup,
        data,
    });
const getAllUserList = (data: PageListReq<Domain.UserQueryParams>) =>
    apiClient.post<PageList<Entity.UserItem>>({
        url: Api.getAllUserList,
        data,
    });
const followUser = (data: Domain.followParams) =>
    apiClient.post<PageList<Entity.UserItem>>({
        url: Api.followUser,
        data,
    });
const getUserRelations = (userId: string) =>
    apiClient.get<any>({
        url: `${Api.getUserRelations}/${userId}`,
    });
const updateUserRelations = (data: any) =>
    apiClient.put<Result<any>>({
        url: Api.updateUserRelations,
        data,
    });
const getOperateUserListInInteractive = (params: PageListReq<Domain.UserQueryParams>) =>
    apiClient.get<PageList<Entity.RIPageAppUserVO>>({
        url: Api.getOperateUserListInInteractive,
        params,
    });
const createUserOperateGroup = (data: any) =>
    apiClient.post<any>({
        url: Api.createUserOperateGroup,
        data,
    });
const createUserBatchOperateGroup = (data: any) =>
    apiClient.post<any>({
        url: Api.createUserBatchOperateGroup,
        data,
    });
const getUserAllocationData = (userId?: string) =>
    apiClient.get<any>({
        url: Api.getUserAllocationData,
        params: { userId },
    });
export default {
    getPersonalUserList,
    getEnterpriseUserList,
    getEnterpriseUserDetail,
    upsertEnterpriseUser,
    updateEnterpriseUser,
    onViewOperator,
    getOperateUserList,
    getUserFollowers,
    getUserFans,
    getUserOperateGroup,
    getAllUserList,
    getOperateUsersList,
    followUser,
    getPersonalUsersList,
    getSchoolList,
    getQsSchool,
    createUserOperateMock,
    getUserRelations,
    updateUserRelations,
    createUserOperateGroup,
    createUserBatchOperateGroup,
    getUserAllocationData,
    getOperateUserListInInteractive,
    upsertOfficeUser,
    updateOfficeUser,
    getOfficeList,
    getOperateAllUsersList,
    getsPersonalUserList
};